import styled from '@emotion/styled';
import { Progress } from '../../atoms/progress/progress';
import { Typography } from '../../atoms/typography/typography';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import { Spacing } from '../../atoms/spacing/spacing';
import { Button } from '@taleemabad/dsm/components';

interface LoadingScreenProps {
  heading?: string | null;
  message?: string | null;
  isActionButtonEnabled?: boolean;
  onClick?: () => void;
}
export const LoadingScreen = ({
  heading = 'Loading Content',
  message = `Please wait while the content is loading`,
  isActionButtonEnabled = false,
  onClick,
}: LoadingScreenProps) => {
  return (
    <LoaderWrapper>
      <Progress type="circular" indeterminate={true} />
      <ContentWrapper>
        <Typography variant="textTitleLargeOnSurface">{heading}</Typography>
        <Spacing marginTop="md">
          <Typography variant="textBodyLargeOnSurfaceVariant">
            {message}
          </Typography>
        </Spacing>
      </ContentWrapper>
      {isActionButtonEnabled && (
        <Button variant="filled" onClick={() => onClick?.()}>
          Got It
        </Button>
      )}
    </LoaderWrapper>
  );
};
const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 80px;
  margin: auto;
  ${mq(BreakpointSizes.desktop)} {
    width: 50%;
    height: 50%;
    bottom: 0;
  }
  z-index: 100;
  background-color: var(--md-sys-color-surface-bright);
`;
const ContentWrapper = styled.div`
  margin-top: var(--rk-spacing-xl);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
